import { isValidElement, type ReactNode } from 'react';
import { Grid, Table, type TableProps } from 'antd';

/** Preserve table actions and pagination while presenting each record as a labelled mobile card. */
export function RecordTable<T extends object>(props:TableProps<T>) {
  const mobile=Grid.useBreakpoint().md===false;
  if(!mobile)return <Table<T> {...props}/>;
  const columns=props.columns?.map(column=>{
    if('children' in column)return column;
    return {...column,width:undefined,fixed:undefined,render:(value:unknown,record:T,index:number)=>{
      const rendered=column.render?column.render(value,record,index):value;
      const cell=rendered&&typeof rendered==='object'&&!isValidElement(rendered)&&'children' in rendered?rendered:null;
      const content=cell?cell.children:rendered;
      const label=typeof column.title==='function'?undefined:column.title;
      const children=<><span className="record-cell-label" aria-hidden="true">{label||'其他'}</span><div className="record-cell-value">{(content??'—') as ReactNode}</div></>;
      return cell?{...cell,children}:children;
    }};
  });
  return <Table<T> {...props} columns={columns} scroll={props.scroll?{...props.scroll,x:undefined}:undefined} className={`record-table ${props.className??''}`}/>;
}
